export const barChartIcon = require("./assets/bar_chart.png")
export const calendarIcon = require("./assets/calendar_icon.svg")
export const checkedCheckbox = require("./assets/checked_checkbox.svg")
export const checkbox = require("./assets/checkbox.svg")